import qs from 'qs';
import { getInternalUrlWithEnv } from './env';

export const baseUrl = getInternalUrlWithEnv('apollo');

const baseParams = { wv: 'lg' };

export function buildUrlWithQuery(base, params) {
    const queryString = params
        ? `?${qs.stringify({ ...baseParams, ...params })}`
        : '';

    return `${base}${queryString}`;
}

export function buildFullUrl(pagePath, params) {
    const fullPagePath = baseUrl + pagePath;
    const result = buildUrlWithQuery(fullPagePath, params);

    return result;
}

// function mergeQuery (params = {}, sourceUrl = location.href) {
//   const url = new URL(sourceUrl)
//   const rawQuery = qs.parse(url.search, { ignoreQueryPrefix: true })
//   const newQuery = { ...rawQuery, ...params }

//   url.search = qs.stringify(newQuery)
//   return url.href
// }



// WEBPACK FOOTER //
// ./src/util/url.js